// Author Lin
// Date 2021-11-16 13:55:17

class MintalMesPrdSmeltingPreheatingKilnStop {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                shiftId = '',
                shiftName = '',
                furnaceId = '',
                furnaceName = '',
                stopNumber = '',
                stopTime = '',
                restartTime = '',
                totalStop = '',
                reason = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.shiftId = shiftId;
            this.shiftName = shiftName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.stopNumber = stopNumber;
            this.stopTime = stopTime;
            this.restartTime = restartTime;
            this.totalStop = totalStop;
            this.reason = reason;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingPreheatingKilnStop();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.shiftId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stopNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.stopNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stopTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.stopTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'restartTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.restartTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'totalStop',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.totalStop',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reason',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.reason',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            stopNumberFilter : '',
            stopTimeRteFilter : '',
            stopTimeLteFilter : '',
            restartTimeRteFilter : '',
            restartTimeLteFilter : '',
            totalStopFilter : '',
            reasonFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'stopNumberFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.stopNumber',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stopTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.stopTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'stopTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.stopTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'restartTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.restartTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'restartTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.restartTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'totalStopFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.totalStop',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'reasonFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.reason',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewerFilter',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.filter.reviewer',
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.shiftName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'stopNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.stopNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stopTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.stopTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                    ,required: true
                        }
                },
                {
                key: 'restartTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.restartTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                    ,required: true
                        }
                },
                {
                key: 'reason',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.reason',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewer',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.reviewer',
                // sortable: true,
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKilnStop.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingPreheatingKilnStop, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        